// extracted by mini-css-extract-plugin
module.exports = {"Box":"Box_Box__3KR3_","h2":"Box_h2__1c6re"};